import React, { useState, useEffect } from "react";
import { makeStyles, Grid, Snackbar } from "@material-ui/core";
import { Input, Dropdown, Button, Checkbox } from 'antd'
import { MinusOutlined, PlusOutlined, CustomerServiceOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons'
import { Document, Page, pdfjs } from 'react-pdf';
import { CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, SwapOutlined } from '@ant-design/icons'
import Modal from "@mui/material/Modal";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js`;

import TranslateModal from "../common/TranslateModal";

import axios from "axios";
import {
  createOrder,
  getFileStatus
} from '../../actions/index'

const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    background: '#f6f6f6'
  },
  main: {
    width: '100%',
    height: '100%',
    background: '#fff',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '20px 0'
  },
  leftBox: {
    borderRight: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rightBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pdfBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pdfMain: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    '& canvas': {
      margin: '0 auto'
    }
  },
  toolbar: {
    position: 'fixed',
    left: '20px',
    bottom: '20px',
    width: '90vw',
    maxWidth: '460px',
    height: '60px',
    borderRadius: '12px',
    padding: '10px 20px',
    background: '#f6f6f6',
    border: '1px solid #ddd',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.hide': {
      bottom: '-60px'
    }
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  numberBtn: {
    width: '32px',
    height: '32px',
    border: '1px solid #d9d9d9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: '#fff',
    '&.left': {
      // borderRight: 'none'
    },
    '&.right': {
      // borderLeft: 'none'
    },
    '&:hover': {
      borderColor: '#1890ff',
      color: '#1890ff'
    }
  },
  numberInput: {
    flex: '1',
    height: '32px'
  },
  toolBtn: {
    width: '80px',
    height: '32px',
    border: '1px solid #d9d9d9',
    background: '#fff',
    textAlign: 'center',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  page: {
    margin: '0 20px',
  },
  greenText: {
    color: '#07AEA0'
  },
  space: {
    height: '32px',
    marginLeft: '20px',
    paddingLeft: '20px',
    borderLeft: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center'
  },
  kefu: {
    fontSize: '20px',
    cursor: 'pointer',
    '&:hover': {
      color: '#1890ff'
    }
  },
  uploadBtn: {
    margin: '0 40px 0 20px',
  },
  hideBtn: {
    fontSize: '20px',
    marginLeft: '20px',
    '&:hover': {
      color: '#1890ff'
    }
  },
  textBtn: {
    '&:hover': {
      color: '#1890ff'
    }
  },
  showBtn: {
    position: 'absolute',
    left: '50%',
    top: '-20px',
    fontSize: '20px',
    transform: 'translateX(-50%)',
    '&:hover': {
      color: '#1890ff'
    }
  },
  translateTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    marginBottom: '10px',
    color: 'rgba(0, 0, 0, 0.85)',
    '& .anticon': {
      marginRight: '16px'
    }
  },
  modalTip: {
    fontSize: '14px',
    color: '#666',
    lineHeight: '24px'
  },
  translateBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "440px",
    maxWidth: "90vw",
    padding: '32px 32px 24px',
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "6px",
  },
  flexBetween: {
    marginTop: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      width: '300px'
    }
  }
});

export default function Preview() {
  const classes = useStyles();

  let timer = ''

  const [previewUrl, setPreviewUrl] = useState('');
 
  const [showToolBar, setShowToolBar] = useState(true);
  const [checked, setChecked] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(1);
  const [scale, setScale] = useState(1);
  const [percent, setPercent] = useState('100%');
  const [translateFile, setTranslateFile] = useState({});


  useEffect(() => {
    initFile()
    
  }, []);
  

  const initFile = () => {
    let url = localStorage.getItem('previewUrl');
    if (url) {
      setPreviewUrl(url)
      
    }
  }


  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  }

  const nextPage = () => {
    if (pageNumber < total) {
      setPageNumber(pageNumber + 1);
    }
  }

  const minusScale = () => {
    if (scale > 0.5) {
      let newScale = Number((scale - 0.1).toFixed(1))
      setScale(newScale);
      setPercent(`${parseInt(newScale * 100)}%`);
    }
  }

  const addScale = () => {
    if (scale < 3) {
      let newScale = Number((scale + 0.1).toFixed(1))
      setScale(newScale);
      setPercent(`${parseInt(newScale * 100)}%`);
    }
  }

  const onDocumentLoadSuccess = (pdf) => {
    setTotal(pdf.numPages);
    // 计算缩放比例
    const containerWidth = document.getElementById('leftBox').offsetWidth;
    pdf.getPage(1).then(page => {
      const viewport = page.getViewport({ scale: 1 });
      const pdfWidth = viewport.width;
      const padding = 24; // 预留内边距
      const autoScale = (containerWidth - padding) / pdfWidth;
      let scale = Math.min(Math.max(autoScale, 0.5), 2.0)
      scale = Number((Math.ceil(scale * 10) / 10).toFixed(1))
      setScale(scale); // 限制缩放范围
      setPercent(`${parseInt(scale * 100)}%`);
    });
  };

  const onloadError = (e) => {
    console.log('error', e)
  }

  return (
    <Grid container className={classes.container}>
      <Grid container xs={12} className={classes.main} id="leftBox">
          {
            previewUrl && (
            <Document
              file={previewUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onloadError}
              options={{
                cMapUrl: '//unpkg.com/pdfjs-dist@3.4.120/cmaps/', // 解决中文显示问题
                cMapPacked: true,
              }}
              className={classes.pdfBox}
            >
              <Page 
                pageNumber={pageNumber} 
                scale={scale}
                className={classes.pdfMain}
              />
            </Document>
            )
          }
      </Grid>

      <Grid className={[classes.toolbar, showToolBar ? 'show' : 'hide'].join(' ')}>
        <Button type="default" onClick={prevPage}>上一页</Button>
        <div className={classes.page}>
          <span className={classes.greenText}>{pageNumber}</span>
          <span>/{total}</span>
          </div>
        <Button type="default" onClick={nextPage}>下一页</Button>
        <div className={[classes.flexCenter, classes.space].join(' ')}>
          <div onClick={minusScale} className={[classes.numberBtn, 'left'].join(' ')}>
            <MinusOutlined />
          </div>
          <Input value={percent} readOnly className={classes.numberInput}></Input>
          <div onClick={addScale} className={[classes.numberBtn, 'right'].join(' ')}>
            <PlusOutlined />
          </div>
        </div>
        <div title="收起">
          <DownCircleOutlined className={classes.hideBtn} onClick={() => setShowToolBar(false)}/>
        </div>
        {
          !showToolBar && (
            <UpCircleOutlined className={classes.showBtn} onClick={() => setShowToolBar(true)}/>
          )
        }
      </Grid>
    </Grid>
  );
}
